import * as React from "react";
import { Carousel } from "react-responsive-carousel";
import { renderArrowNext, renderArrowPrev } from "./Arrows";
import { Slide, SlideTab } from "./SlideType";
import SliderTabs from "./SliderTabs";
import "rc-tabs/assets/index.css";
import PictureProvider from "../../components/Picture";
import { IDynamicBlockComponent } from "../../dynamicPageBuilder/IDynamicBlockComponent";
import { PictureData } from "../../../types/PictureData";

type SlideElement = {
  content: string;
  title: string;
  picture: PictureData;
};

type SliderProps = {
  positionDesktop: "left" | "right";
  element: Record<string, SlideElement>;
  tiles: Record<string, SlideTab>;
};

const SliderWithTabs: React.FunctionComponent<IDynamicBlockComponent> = ({
  blockData,
}): React.ReactElement => {
  const {
    data: { element, positionDesktop, tiles },
  } = blockData as { data: SliderProps };

  const slides = Object.values(element);
  const tilesForSlides = Object.values(tiles);

  const parsedSlides: Array<Slide> = slides.map((slide, index) => {
    const tabs = tilesForSlides.filter(
      (tile) => tile.parent_slide === index + 1
    );

    return { ...slide, tabs };
  });

  return (
    <div className="sliderWithTabs">
      <div className="desktop-container">
        <Carousel
          autoPlay
          infiniteLoop={parsedSlides.length > 1}
          interval={15000}
          showThumbs={false}
          showStatus={false}
          stopOnHover
          renderArrowPrev={renderArrowPrev}
          renderArrowNext={renderArrowNext}
          preventMovementUntilSwipeScrollTolerance
          swipeScrollTolerance={100}
        >
          {parsedSlides.map((slide) => (
            <div key={`slide_${slide.title}`} className="sliderWithTabs__slide">
              <h2>{slide.title}</h2>
              <div
                className={`sliderWithTabs__item ${
                  positionDesktop === "right"
                    ? "sliderWithTabs__item--reverse"
                    : ""
                }`}
              >
                {slide.tabs.length > 0 ? (
                  <SliderTabs tabs={slide.tabs} />
                ) : (
                  <div dangerouslySetInnerHTML={{ __html: slide.content }} />
                )}
                <div className="sliderWithTabs__rightSection">
                  <PictureProvider data={slide.picture} />
                </div>
              </div>
            </div>
          ))}
        </Carousel>
      </div>
    </div>
  );
};

export default SliderWithTabs;
